var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"field my-2",style:({ width: _vm.width, height: _vm.height })},[_c('span',{staticClass:"field__label",style:({
      color: _vm.labelColor, 'font-weight': _vm.fontWeight })},[_vm._v(_vm._s(_vm.label))]),_c('input',{staticClass:"field__value",style:({
        color: _vm.valueColor,
        'font-weight': _vm.fontWeight,
        'text-align': 'right',
      }),attrs:{"readonly":""},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }